import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, MagazziniArticoliLottiSeriali, MagArtLottiSerialiModel } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class MagazziniArticoliLottiSerialiService extends CrudGenericsService<MagazziniArticoliLottiSeriali, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/MagazziniArticoliLottiSeriali`);
    this.base = `${env.apiUrl}/api/MagazziniArticoliLottiSeriali/`;
  }

  GetMagArtLotti_ByMagArt(id: number): Observable<MagazziniArticoliLottiSeriali[]> {
    const u = `${this.base}GetMagArtLotti_ByMagArt?id=${id}`;
    return this.http.get<MagazziniArticoliLottiSeriali[]>(u);
  }

  GetMagArtLotti_ByArt(id: number): Observable<MagArtLottiSerialiModel[]> {
    const u = `${this.base}GetMagArtLotti_ByArt?id=${id}`;
    return this.http.get<MagArtLottiSerialiModel[]>(u);
  }
}
